export const patientHeaderCol: any = [
  { key: 'id', title: 'id', align: 'left' },
  {
    key: 'title',
    title: 'Title',
    align: 'left',
    width: '12rem !important',
    isShow: true,
    style: {
      // whiteSpace: "nowrap",
      // position: "sticky",
      // left: "0",
      // background: "white",
      // zIndex: 1000
    },
  },
  {
    key: 'task_status',
    title: 'Status',
    align: 'left',
    width: '3.8rem !important',
    isShow: true,
  },
  {
    key: 'delay_note',
    title: 'Delay comment',
    align: 'left',
    width: '6rem',
    isShow: true,
  },
  {
    key: 'details',
    title: 'Details',
    align: 'left',
    width: '2.8em',
    isShow: true,
  },
  {
    key: 'stage',
    title: 'Stage',
    align: 'left',
    width: '5rem',
    isShow: true,
  },
  {
    key: 'assigned_to',
    title: 'Assigned to',
    align: 'left',
    width: '6rem',
    isShow: true,
  },
  {
    key: 'assignment_date',
    title: 'Assignment date',
    align: 'left',
    width: '5rem',
    isShow: true,
  },
  {
    key: 'due_date',
    title: 'Due date',
    align: 'left',
    width: '5rem',
    isShow: true,
  },
  {
    key: 'owner_role',
    title: 'Owner role',
    align: 'left',
    width: '4rem',
    isShow: true,
  },
  { key: 'owner', title: 'Owner', align: 'left', width: '6rem', isShow: true },
  {
    key: 'completion_date',
    title: 'Completion date',
    align: 'left',
    width: '5rem',
    isShow: true,
  },
  { key: 'notes', title: 'Note', align: 'left', width: '8rem', isShow: true },
]

export const taskHeaderCol: any = [
  { key: 'id', title: 'id', align: 'left' },
  { key: 'name', title: 'Name', align: 'left', width: '8rem', isShow: true },
  { key: 'MRN', title: 'MRN', align: 'left', width: '7rem', isShow: true },
  { key: 'DOB', title: 'DOB', align: 'left', width: '4.6rem', isShow: true },
  { key: 'ref_id', title: 'ID', align: 'left', width: '3.5rem', isShow: true },
  {
    key: 'phone',
    title: 'Phone',
    align: 'left',
    width: '4.6rem',
    isShow: true,
  },
  { key: 'title', title: 'Title', align: 'left', width: '10rem', isShow: true },
  { key: 'priority', title: 'Priority', align: 'center', width: '2.5rem', isShow: true },
  { key: 'subsampled', title: 'Top daily task', align: 'left', width: '5rem', isShow: true },
  {
    key: 'task_status',
    title: 'Status',
    align: 'left',
    width: '3.8rem !important',
    isShow: true,
  },
  {
    key: 'delay_note',
    title: 'Delay comment',
    align: 'left',
    width: '6rem',
    isShow: true,
  },
  { key: 'notes', title: 'Note', align: 'left', width: '6rem', isShow: true },
  {
    key: 'details',
    title: 'Details',
    align: 'left',
    width: '3.6rem',
    isShow: true,
  },
  { key: 'hospital_name', title: 'Hospital', align: 'left', width: '5rem', isShow: true },
  {
    key: 'program',
    title: 'Program',
    align: 'left',
    width: '4.5rem',
    isShow: true,
  },
  {
    key: 'stage',
    title: 'Stage',
    align: 'left',
    width: '5rem',
    isShow: true,
  },
  {
    key: 'assigned_to',
    title: 'Assigned to',
    align: 'left',
    width: '6rem',
    isShow: true,
  },
  {
    key: 'assignment_date',
    title: 'Assignment date',
    align: 'left',
    width: '5rem',
    isShow: true,
  },
  {
    key: 'due_date',
    title: 'Due date',
    align: 'left',
    width: '5rem',
    isShow: true,
  },
  {
    key: 'owner_role',
    title: 'Owner role',
    align: 'left',
    width: '4rem',
    isShow: true,
  },
  { key: 'owner', title: 'Owner', align: 'left', width: '6rem', isShow: true },
  {
    key: 'completion_date',
    title: 'Completion date',
    align: 'left',
    width: '5rem',
    isShow: true,
  },
]
